<h2 #portfolio>portfolio.</h2>
<div class="portfolio_container">
    <a class="portfolio_card" [routerLink]="['schneidereipd']">
        <img class="card_img" alt="Kartenbild Schneiderei Petra Dolling" src="../../assets/projects/schneidereipd/schneidereipd-img-card-100x100.webp">
        <div class="portfolio_info">
            <div class="portfolio_subheadline">Website</div>
            <div class="portfolio_headline">Schneiderei Petra Dolinger</div>
            <div class="portfolio_description">Website für eine lokale Schneiderei mit hohem emotionalen Wert</div>
            <div class="chip_portfolio">
                <app-chip [chips]='schneiderei'></app-chip>
            </div>
        </div>
    </a>
    <!-- <div class="portfolio_card">
        <img class="card_img" src="../../assets/cards/PSBWasnerCard.jpg">
        <div class="portfolio_info">
            <div class="portfolio_subheadline">Wissensdatenbank</div>
            <div class="portfolio_headline">PSB Wasner GmbH</div>
            <div class="portfolio_description">Confluence Datenbank für den internen KnowHow Austausch</div>
            <div class="chip_portfolio">
                <app-chip [chips]='wasner'></app-chip>
            </div>
        </div>
    </div> -->
    <a class="portfolio_card" [routerLink]="['backstage']">
        <img class="card_img" alt="Kartenbild Backstage" src="../../assets/cards/nvt-img-card-100x100.webp">
        <div class="portfolio_info">
            <div class="portfolio_subheadline">Intranet</div>
            <div class="portfolio_headline">Backstage</div>
            <div class="portfolio_description">Ein Vereinsintranet auf Angular und ASP.NET Basis</div>
            <div class="chip_portfolio">
                <app-chip [chips]='backstage'></app-chip>
            </div>
        </div>
    </a>
    <a class="portfolio_card" [routerLink]="['nvt-tickets']">
        <img class="card_img" alt="Kartenbild NVT-Tickets" src="../../assets/projects/Backstage/theater-img-card-100x100.webp">
        <div class="portfolio_info">
            <div class="portfolio_subheadline">Eventticketsystem</div>
            <div class="portfolio_headline">Neuburger Volkstheater Tickets</div>
            <div class="portfolio_description">Vereinseigenes Eventticketsystem in Wordpress</div>
            <div class="chip_portfolio">
                <app-chip [chips]='tickets'></app-chip>
            </div>
        </div>
    </a>
    <a class="portfolio_card" [routerLink]="['volkstheater']">
        <img class="card_img" alt="Kartenbild Volkstheater" src="../../assets/projects/Volkstheater/jugend-img-card-100x100.webp">
        <div class="portfolio_info">
            <div class="portfolio_subheadline">Website</div>
            <div class="portfolio_headline">Neuburger Volkstheater e.V.</div>
            <div class="portfolio_description">Neugestaltung des Internetauftritts des Neuburger Volkstheaters</div>
            <div class="chip_portfolio">
                <app-chip [chips]='volkstheater'></app-chip>
            </div>
        </div>
    </a>
</div>
<!-- <h2 #portfolio>demos.</h2>
<div class="portfolio_container">
    <a class="portfolio_card" routerLink="Vereinsintranet">
        <img class="card_img" alt="Kartenbild Backstage" src="../../assets/cards/nvt-img-card-100x100.webp">
        <div class="portfolio_info">
            <div class="portfolio_subheadline">Intranet</div>
            <div class="portfolio_headline">Demo Backstage</div>
            <div class="portfolio_description">Demo Zugang zum Vereinsintranet</div>
            <div class="chip_portfolio">
                <app-chip [chips]='demo_backstage'></app-chip>
            </div>
        </div>
    </a>
</div> -->
